export const SectionAboutUsTranslationsCs = {
  'About Us': 'O nás',
  'AniraK...':
    "AniraKids je půjčovna společenských šatů a obleků pro děti i dospělé. Vyberte si oblečení z našeho katalogu na oslavu, svatbu nebo rodinné focení.",
};
